import { ListingDetails, SaleDetails } from 'src/WebApiController';

import { BuyerSection } from '../ManagedMarketplaceSale/components/BuyerSection';
import { MarketplaceSaleInfoSection } from '../ManagedMarketplaceSale/components/MarketplaceSaleInfoSection';
import { TicketSection } from '../ManagedMarketplaceSale/components/TicketSection';
import { ModalBodyDataContainer } from '../Modal/Modal.styled';
import { MarketplaceSection } from './components/MarketplaceSection';

export const MarketplaceSaleBody = ({
  listing,
  sale,
  disabled,
}: {
  listing?: ListingDetails;
  sale?: SaleDetails;
  disabled?: boolean;
}) => {
  const isEdit = sale != null;
  return (
    <ModalBodyDataContainer data-testid="marketplace-sale-body">
      {!isEdit && (
        <MarketplaceSection disabled={disabled} officeId={listing?.officeId} />
      )}
      <BuyerSection disabled={disabled} saleReadOnly={sale} />
      <MarketplaceSaleInfoSection disabled={disabled} />
      {!isEdit && (
        <TicketSection
          disabled={disabled || sale != null}
          maxQuantity={listing?.availQty}
          deliveryType={listing?.delivType}
          tickets={listing?.tickets ?? []}
          listing={listing}
        />
      )}
    </ModalBodyDataContainer>
  );
};
